<template>
  <v-container fluid>
    <VouchersClientsTable class="pb-4">
      <template v-slot:actions="{ dataset }">
        <avs-exportButton
          :data="dataset"
          :prepare="preFmtData"
          :name="$t('actions.export_')"
          :spantext="$t('actions.export', { entity: $t('bons clients') })"
        />
      </template>
    </VouchersClientsTable>
  </v-container>
</template>
<script>
import { VouchersClientsTable } from "@/components"
import { fmtCfsiData } from "@/utils/download"

export default {
  name: "ClientVoucherView",
  components: { VouchersClientsTable },
  methods: {
    preFmtData(dataset) {
      return fmtCfsiData(dataset)
    }
  }
}
</script>
